import { useMemo } from 'react';
import { useCompany } from '../hooks/company';

export const ReChannelName = ({ channel }: { channel?: string }) => {
  const { currentUser } = useCompany();
  const channelName = useMemo(() => {
    if (currentUser.isSuperAdmin) {
      return channel;
    }
    if (channel?.startsWith('RE-')) {
      return channel.slice(3);
    }
    return channel;
  }, [channel, currentUser.isSuperAdmin]);
  return <>{channelName}</>;
};
